import { things as storeEntities } from '@gdi/store-things';

export const actions = storeEntities.actions;
export const selectors = storeEntities.selectors;
export const reducers = storeEntities.reducers;
export const initialState = storeEntities.initialState;
export const endpointsConfig = storeEntities.endpointsConfigOverrides;
export const clearState = storeEntities.clearState;
